export default {
  TOGGLE_ITEM_IN_WISH_LIST (state, item) {
    const index = state.wishList.findIndex(i => i.objectID === item.objectID)
    if (index < 0) {
      state.wishList.push(item)
    } else {
      state.wishList.splice(index, 1)
    }
  },
  REMOVE_ITEM_FROM_CART (state, item) {
    const index = state.cartItems.findIndex(i => i.id === item.id)
    if (index > -1) { state.cartItems.splice(index, 1) }
    localStorage.setItem('cartItems', JSON.stringify(state.cartItems))
  },
  ADD_ITEM_IN_CART (state, item) {
    const cartItem = JSON.parse(JSON.stringify(item))
    state.cartItems.push(cartItem)
    state.restaurant_id = cartItem.restaurant_id
    localStorage.setItem('cartItems', JSON.stringify(state.cartItems))
  },
  UPDATE_ITEM_IN_CART (state, item) {
    const cartItem = JSON.parse(JSON.stringify(item))
    const itemIndex = state.cartItems.findIndex(
      (item) => item.id === cartItem.id
    )
    //state.cartItems[itemIndex] = cartItem
    state.cartItems.splice(itemIndex, 1, cartItem)
    localStorage.setItem('cartItems', JSON.stringify(state.cartItems))
  },
  SET_CART (state, cart) {
    state.cartItems = cart
    if (cart.length <= 0) {
      state.restaurant_id = null
    } else {
      state.restaurant_id = cart[0].restaurant_id
    }
    localStorage.setItem('cartItems', JSON.stringify(state.cartItems))
  },
  UPDATE_ITEM_QUANTITY (state, payload) {
    state.cartItems[payload.index].quantity = payload.quantity
    localStorage.setItem('cartItems', JSON.stringify(state.cartItems))
  }
}

